import React, { useEffect, useState } from 'react'
import TableComponent from 'components/Table'
import { CreditRowItem } from '../../CreditRowItem'

const ActiveTableList = (props: any) => {
    return (
        <TableComponent
        columns={props.columns}
        className={"credit-table  transfer-table salary-table  home_account_opt_table activeDepositTable deposit-table" + (props.data?.length === 0 ? " empty_salary_table" : "")}
        // className="credit-table transfer-table salary-table home_account_opt_table"
        onRow={props.onRow}
        rowClassName={(index:any) =>
          index % 2 === 0 ? 'table-row-dark' : 'table-row-light'
        }
        data={props.data}
        scroll={{ x: 1000 }}
        pagination={false}
        rowSelection={false}
        pageSize={3}
        ellipsis
        bordered={false}
        onChange={props.onChange}
        expandedRowKeys={props.expandedRowKeys}
        onExpand={props.onExpand}
        
        expandable={{
          expandedRowRender: (record: any) => {
            return (
              <CreditRowItem
                leftItems={record}
                styleCreditRowColum={{
                  position: 'relative',
                  right: 15,
                }}
                handleRowClose={props.handleRowClose}
                labelStyle={'depositTable__panelLabel'}
                tableData={record}
              />
            )
          },
          // rowExpandable: (record:any) => {                 
          //   if (props.firstRow) {
          //     return false;
          //   } else {
          //     return true;
          //   }
          // },
          expandRowByClick: true,
          expandIconColumnIndex: -1,
          showExpandColumn: false,
          // expandIcon: () => null
        }}
      />
    )
}
export default ActiveTableList